import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { PayoutDetailsComponent } from '../../pages/payout-details/payout-details.component'
import { MatDialog } from '@angular/material/dialog'
import { Subscription } from 'rxjs'
import {
	AcceptRejectPayoutModel,
	ClientPayoutList,
	clientPayout,
} from '../../models/client-payout'
import { TranslateService } from '@ngx-translate/core'
import { PayoutService } from '../../services/payout.service'
import { PaymentPayoutStatus } from '../../models/client-payout.enum'
import { AcceptRejectClientPayoutPopupComponent } from '../accept-reject-client-payout-popup/accept-reject-client-payout-popup.component'
import { Router } from '@angular/router'

@Component({
	selector: 'app-client-payout-table',
	templateUrl: './client-payout-table.component.html',
	styleUrls: ['./client-payout-table.component.scss'],
})
export class ClientPayoutTableComponent implements OnInit {
	@Input() payouts: ClientPayoutList[] = []
	subscription = new Subscription()
	@Input() clientPayoutFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		keyword: '',
		activeTab: 1,
	}
	@Input() totalCount = 0
	@Output() refresh = new EventEmitter()

	PaymentPayoutStatus = PaymentPayoutStatus
	clientDeatailsData!: clientPayout
	acceptRejectPayoutModel: any = {
		id: 0,
		payoutAmount: 0,
		notes: '',
		attachementUrl: '',
	}
	constructor(
		private dialog: MatDialog,
		public translate: TranslateService,
		private payoutService: PayoutService,
		private router: Router
	) {}

	ngOnInit(): void {}
	openDetailss(id: number) {
		this.subscription.add(
			this.payoutService.getClientPayoutDetails(id).subscribe((res: any) => {
				this.clientDeatailsData = res.result
				this.dialog.open(PayoutDetailsComponent, {
					width: '75%',
					height: '90%',
					disableClose: true,
					data: {
						client: true,
						clientData: this.clientDeatailsData,
					},
				})
			})
		)
	}

	openSelect(id: number) {
		this.subscription.add(
			this.payoutService.getClientPayoutDetails(id).subscribe((res: any) => {
				this.clientDeatailsData = res.result

				this.dialog
					.open(AcceptRejectClientPayoutPopupComponent, {
						width: '75%',
						height: '90%',
						data: {
							clientData: this.clientDeatailsData,
						},
					})
					.afterClosed()
					.subscribe({
						next: (res) => {
							if (res) {
								this.acceptRejectPayoutModel.id = this.clientDeatailsData.id
								this.acceptRejectPayoutModel.attachementUrl = res.image
								this.acceptRejectPayoutModel.notes = res.notes
								this.acceptRejectPayoutModel.payoutAmount =
									this.clientDeatailsData.requestedAmount
								this.acceptRejectPayoutModel = {
									...this.acceptRejectPayoutModel,
								}

								res.type == true
									? this.payoutService
											.acceptClientPayout(this.acceptRejectPayoutModel)
											.subscribe((res: any) => {
												if (res) {
													this.refresh.emit(true)
												}
											})
									: this.payoutService
											.rejectClientPayout(this.acceptRejectPayoutModel)
											.subscribe((res: any) => {
												if (res) {
													this.refresh.emit(true)
												}
											})
							}
						},
					})
			})
		)
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
